import React from 'react';
import { Zoom  } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
const images = [
  './Assets/carousel_banner_01.gif',
  './Assets/carousel_banner_02.png',
  './Assets/carousel_banner_03.png',
  './Assets/carousel_banner_04.png',
  './Assets/carousel_banner_05.gif',
];

const Slideshow = () => {
    return (
      <div className="slide-container">
        <Zoom  scale={0.4}>
          {
            images.map((each, index) => <img key={index} style={{width: "100%"}} src={each} alt="carousel img"/>)
          }
        </Zoom >
      </div>
    )
}

export default Slideshow;
